import * as React from "react";
import { type ITextFieldStyles } from "@fluentui/react/lib/TextField";
import type { LtlFormCapabilities } from "@src/types/api";
import type { BolDetailsFormValues } from "./bolDetailsFormTypes";
import { BolDetailsAddressOriginBlock } from "./BolDetailsAddressOriginBlock";
import { BolDetailsAddressPartyBlock } from "./BolDetailsAddressPartyBlock";

export interface BolDetailsAddressGridProps {
  form: BolDetailsFormValues;
  errors: Record<string, string>;
  caps: LtlFormCapabilities;
  onFieldBlur?: () => void;
  handleInputChange: (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => void;
  getTextFieldStyles: (fieldName: keyof BolDetailsFormValues) => Partial<ITextFieldStyles>;
}

export function BolDetailsAddressGrid(props: BolDetailsAddressGridProps): React.ReactElement {
  return (
    <>
      <BolDetailsAddressOriginBlock {...props} />
      <BolDetailsAddressPartyBlock {...props} />
    </>
  );
}
